( function () {
	'use strict';

	function htmlToPlaintext () {
		return function ( text ) {
			if ( text ) {
				return String( text ).replace( /<[^>]+>/gm, '' );
			}
		};
	}

	angular
		.module( 'app.components' )
		.filter( 'htmlToPlaintext', htmlToPlaintext );

	htmlToPlaintext.$inject = [];
} )( );
